import { render, staticRenderFns } from "./order-nav.vue?vue&type=template&id=5bac124e&scoped=true"
import script from "./order-nav.vue?vue&type=script&lang=js"
export * from "./order-nav.vue?vue&type=script&lang=js"
import style0 from "./order-nav.vue?vue&type=style&index=0&id=5bac124e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac124e",
  null
  
)

export default component.exports